<template>
  <div>
    <div class="cover-table">
      <Table
        border
        style="width: 100%;"
        :loading="loading"
        :columns="tableColumns"
        :data="tableData"
        highlight-row
      >
        <!-- <template slot-scope="{ row, index }" slot="action">
                    <span class="pointer" @click="handleDeal('projectDetail',row.id)">详情</span>
                </template> -->
      </Table>
    </div>
  </div>
</template>
<script>
import tableTwoMixin from "@/components/tableTwoMixin";
export default {
  mixins: [tableTwoMixin],
  data() {
    return {
      tableColumns: [
        {
          title: "序号",
          type: "index",
          width: 70,
          fixed: "left",
          align: "center",
        },
        {
          title: "项目编号",
          key: "projectId",
          minWidth: 100,
          tooltip: true,
          align: "center",
        },
        {
          title: "培训日期",
          key: "trainingDate",
          minWidth: 210,
          tooltip: true,
          align: "center",
        },
        {
          title: "培训时长",
          key: "trainingDuration",
          minWidth: 180,
          tooltip: true,
          align: "center",
        },
        {
          title: "培训名称",
          key: "trainingName",
          minWidth: 140,
          tooltip: true,
          align: "center",
        },
        {
          title: "培训类型代码",
          key: "trainingTypeCode",
          minWidth: 180,
          tooltip: true,
          align: "center",
        },
        {
          title: "培训人",
          key: "trainer",
          minWidth: 210,
          tooltip: true,
          align: "center",
        },
        {
          title: "培训机构",
          key: "trainingOrg",
          minWidth: 210,
          tooltip: true,
          align: "center",
        },
        {
          title: "培训地址",
          key: "trainingAddress",
          minWidth: 210,
          tooltip: true,
          align: "center",
        },
        // { title: '参建班组', key: 'teamName', minWidth: 210, tooltip: true },
        {
          title: "培训简述",
          key: "description",
          align: "center",
          minWidth: 210,
          tooltip: true,
        },
        { title: "附件", key: "attachments", minWidth: 210, tooltip: true },
        {
          title: "参与培训的工人",
          key: "workers",
          align: "center",
          minWidth: 180,
          tooltip: true,
        },
        {
          title: "数据来源",
          key: "projectAreaCode",
          align: "center",
          minWidth: 140,
          tooltip: true,
        },
      ],
    };
  },
};
</script>
